import { computed } from 'vue'
import { useRoute } from 'vue-router'

/** 마이쇼핑 레이아웃 안에 끼워진 페이지인지 (배경·패딩 축소용) */
export function useMallMypageEmbedded() {
  const route = useRoute()
  return computed(() => route.matched.some((record) => Boolean(record.meta?.mypage)))
}
